import { Button } from "@material-ui/core"
import { get } from "lodash"
import { makeStyles } from "@material-ui/core/styles"
import Avatar from "@material-ui/core/Avatar"
import Box from "@material-ui/core/Box"
import CommaPrice from "src/features/Utils/CommaPrice"
import Divider from "@material-ui/core/Divider"
import Grid from "@material-ui/core/Grid"
import React, { useState } from "react"
import Link from "@material-ui/core/Link"
import Typography from "@material-ui/core/Typography"

import NoImage from "src/assets/no-image.jpg"

import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import isEmpty from "lodash/isEmpty"

const useStyles = makeStyles((theme) => ({
  avatar: { width: 67, height: 67 },
  promo: {
    textDecoration: "line-through",
  },
}))

const BundleItem = ({ image, name, line1, line2, amount }) => {
  const classes = useStyles()
  return (
    <Box display="flex" mb={1}>
      <Avatar
        src={image || NoImage}
        variant="rounded"
        className={classes.avatar}
      />
      <Box mx={2}>
        <Box mb={0.5}>{name}</Box>
        <Box mb={0.5} fontSize="14px">
          {line1}
        </Box>
        <Box mb={0.5} fontSize="14px" color="text.secondary">
          {line2}
        </Box>
      </Box>
      <Box ml="auto">x {amount}</Box>
    </Box>
  )
}

export default ({ item, action }) => {
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const openModal = () => {
    setOpen(true)
  }

  const closeModal = () => {
    setOpen(false)
  }

  const supply = get(item, "supply", []).filter((el) => !isEmpty(el))
  const medicine = get(item, "medicine", []).filter((el) => !isEmpty(el))

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={1}>
          <Avatar
            src={get(item, "cover_img") || NoImage}
            variant="rounded"
            className={classes.avatar}
          />
        </Grid>
        <Grid item xs={4}>
          <Box mb={2}>{get(item, "name")}</Box>
          <Box>
            <Link color="secondary" onClick={openModal}>
              Show Details
            </Link>
          </Box>
        </Grid>
        <Grid item xs={4}>
          <Box
            display="flex"
            height="100%"
            alignItems="center"
            justifyContent="center"
          >
            <Box fontSize={16} color="primary.main">
              {CommaPrice(get(item, "promo_price", 0))}
            </Box>
            <Box
              fontSize="12px"
              mt={0.3}
              ml={0.6}
              color={"text.secondary"}
              className={classes.promo}
            >
              {CommaPrice(
                get(item, "promo_price", 0) + get(item, "discount", 0)
              )}
            </Box>
          </Box>
        </Grid>
        <Grid item xs={3}>
          <Box
            display="flex"
            height="100%"
            alignItems="center"
            justifyContent="center"
          >
            <Button color="secondary" onClick={action}>
              ADD TO CART
            </Button>
          </Box>
        </Grid>
      </Grid>
      <Box mt={1} mb={1}>
        <Divider />
      </Box>
      <Dialog
        fullWidth
        aria-labelledby="ckeckout-dialog-title"
        aria-describedby="ckeckout-dialog-description"
        open={open}
        onClose={closeModal}
        maxWidth="md"
      >
        <DialogTitle id="ckeckout-dialog-title">
          {get(item, "name")}
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" gutterBottom>
            {get(item, "detail")}
          </Typography>
          <Typography variant="subtitle2" color="textSecondary" gutterBottom>
            Have {medicine.length + supply.length} package(s) of Bundle
          </Typography>
          <Box p={1}>
            {medicine.map((record) => {
              const _id = get(record, "_id")
              const image = get(record, "cover_img", "")
              const name = get(record, "presentation.search_name", "")
              const line1 = `${record.multiplier} ${record.presentation.presentation_name.name} x ${record.presentation.quantity} ${record.presentation.presentation_unit.name} / ${record.container.name}`
              const line2 = get(record, "presentation.generics", [])
                .map((gen) => gen.name + " " + gen.strength)
                .join(", ")
              const amount = get(record, "amount", "")
              return (
                <BundleItem
                  key={_id}
                  image={image}
                  name={name}
                  line1={line1}
                  line2={line2}
                  amount={amount}
                />
              )
            })}
            {supply.map((record) => {
              const _id = get(record, "_id")
              const image = get(record, "cover_img", "")
              const name = get(record, "supply.search_name", "")
              const line1 =
                get(record, "multiplier", "") +
                " / " +
                get(record, "container.name", "")
              const line2 = get(record, "supply.description", "")
              const amount = get(record, "amount", "")
              return (
                <BundleItem
                  key={_id}
                  image={image}
                  name={name}
                  line1={line1}
                  line2={line2}
                  amount={amount}
                />
              )
            })}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeModal} color="primary">
            BACK
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}
